import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-menu-top-popup',
  templateUrl: './toppopup.component.html',
  styleUrls: [
    './toppopup.component.scss'
  ]
})
export class TopMenuPopupComponent implements OnInit {

	@Input() hideDropdown = true;
  	@Input() menus: any[];
  
  	@Output() public dropdownStateChanged = new EventEmitter<any>();

	@Output() selectedMenuEvent = new EventEmitter<any>();

	activeMenu: any;

	@ViewChild('dropdownMenu', { static: false }) dropdownMenuElement: ElementRef;

	mousepointerIndex;

	selectedMenu: any;
	menuNavigation = '';

	constructor(
	) { 
		this.menuNavigation = environment.menuNavigation;
	}

	ngOnInit() {
	}

	onHandleDropdown($event: any) {
		this.hideDropdown = true;
		this.activeMenu = null;
	}

	doActivateMenu(activeMenu: any, index) {
		this.mousepointerIndex = index;
		this.hideDropdown = false;
		this.activeMenu = activeMenu;
		// this.dropdownMenuElement.nativeElement.style.display = 'block';
	}

	doDeactivateMenu(deactiveMenu: any) {
	}

	public doSelectMenu(menu: any) {
		if (this.selectedMenu === menu) {
			this.selectedMenu = null;
		} else {
			this.selectedMenu = menu;
		}
	}
}
